var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"z-index":"20000 !important"}},_vm._l((_vm.areas),function(area,index){return _c('SlicedImageLayer',{key:index,attrs:{"bounds":area.bounds,"images":area.images}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }